import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class InboundRouteService extends ServiceCRUD {
  constructor() {
    super('/api/inbound-route');
  }
}

export default new InboundRouteService();
